/**
 * Mock 数据
 * 后端接口未就绪时的兜底数据，接口调通后无需改动页面代码
 */

export const mockCompanyInfo = {
  name: '好美意',
  slogan: '好家好美意，装点每一个家',
  intro:
    '“好美意”-云之富（上海）数据服务有限公司，是国内领先的家装消费场景服务平台，提供服务包括：家装场景商户联盟拓展和客户转化、“家装节”营销活动组织实施、家装优选商城运营、装修现场勘验服务等。',
  services: [
    '家装场景商户联盟拓展和客户转化',
    '家装节”营销活动组织实施',
    '家装优选商城运营',
    '装修现场勘验服务',
  ],
  facts: [
    { icon: '🏛️', title: '业务布局', text: '业务覆盖上海、重庆、江苏省、四川省、广东省、陕西省、湖北省、安徽省等区域。' },
    { icon: '👥', title: '团队积淀', text: '团队拥有超过20年运营管理经验，以及家装消费场景商户资源积累。' },
    { icon: '🏅', title: '资质认证', text: '获高新技术企业认证与科技型中小企业认证。' },
  ],
  stats: [
    { label: '服务客户', value: '11万+' },
    { label: '合作商户', value: '1万+' },
    { label: '合作机构产品', value: '300+' },
    { label: '人员经验', value: '20年+' },
  ],
  milestones: [
    { year: '2018', event: '成立于上海，核心团队组建成功' },
    { year: '2019', event: '商业模式试点完成' },
    { year: '2020~2025', event: '商业模式基本完成，业务扩展至88个城市；合作商户突破万家。' },
    { year: '2026', event: '稳住基本盘，发力家居市场，构建消费闭环' },
  ],
};

export const mockProducts = [
  {
    id: 1,
    category: 'furniture',
    icon: '🛋️',
    title: '全屋家具定制',
    desc: '免费量房设计，进口设备生产，环保板材，全屋家具一站式定制。',
    features: ['免费量房', 'E0级环保板材', '10年质保'],
  },
  {
    id: 2,
    category: 'furniture',
    icon: '🛏️',
    title: '精品成品家具',
    desc: '严选国内外300+知名品牌，沙发、床垫、餐桌等成品家具应有尽有。微信扫码进入小程序选购。',
    features: ['品牌直供', '正品保障', '送货安装'],
    hasQRCode: true,
  },
  {
    id: 3,
    category: 'furniture',
    icon: '🏠',
    title: '整体软装设计',
    desc: '资深设计师团队，从窗帘布艺到灯具饰品，打造有温度的家。',
    features: ['一对一设计', '效果图呈现', '落地陪购'],
  },
  {
    id: 7,
    category: 'survey',
    icon: '📐',
    title: '勘察服务',
    desc: '专业团队上门对房屋装修现场进行全面勘验，出具详细勘察报告，为您的装修决策提供专业依据。收费服务，预约后工程师将上门服务。',
    features: ['上门勘察', '专业报告', '收费服务'],
    isPaid: true,
  },
];

export const mockContactInfo = {
  address: '上海市徐汇区徐虹北路20号3楼305',
  phone: '021-64157750',
  email: 'service@Homeez.cn',
  hours: '周一至周日 9:00 - 21:00',
};

// 首页聚合接口 /off/home 的兜底数据（后端未就绪时使用）
export const mockHomeData = {
  banner: {
    title: '好家好美意',
    subtitle: '装点每一个家',
    desc: '家居销售 · 整体家装 · 软装搭配，一站式家居解决方案，让每个家庭轻松拥有理想的家。',
  },
  stats: [
    { label: '服务客户', value: '11万+' },
    { label: '合作商户', value: '1万+' },
    { label: '合作机构产品', value: '300+' },
    { label: '人员经验', value: '20年+' },
  ],
  hotProducts: [
    { id: 1, icon: '🛋️', title: '全屋家具定制', desc: '免费量房设计，E0级环保板材，全屋家具一站式定制。' },
    { id: 7, icon: '📐', title: '勘察服务', desc: '专业团队上门勘验，出具详细报告，为装修决策提供专业依据。' },
    { id: 3, icon: '🏠', title: '整体软装设计', desc: '资深设计师团队，打造有温度的家。' },
  ],
};

// 公司发布的活动（首页活动分类板块）
export const mockActivities = [
  {
    id: 5,
    category: 'store',
    tag: '到店活动',
    title: '周末家居市集',
    desc: '每周六日门店举办家居市集，现场抽奖、亲子手工、设计师面对面答疑。',
    date: '每周六日 10:00-18:00',
    icon: '🛍️',
  },
  {
    id: 6,
    category: 'store',
    tag: '到店活动',
    title: '免费量房日',
    desc: '每月 8 号为免费量房日，预约即享资深设计师上门量房与方案初稿。',
    date: '每月 8 号',
    icon: '📐',
  },
  {
    id: 7,
    category: 'member',
    tag: '会员专享',
    title: '老客户转介绍礼',
    desc: '会员推荐好友成交，双方各得 500 元家居抵用券，上不封顶。',
    date: '长期有效',
    icon: '🎁',
  },
  {
    id: 8,
    category: 'member',
    tag: '会员专享',
    title: '会员日双倍积分',
    desc: '每月 18 号会员日消费享双倍积分，积分可抵现、换购好礼。',
    date: '每月 18 号',
    icon: '⭐',
  },
];

// 首页付费尊享服务（需付费认购的增值模块）
export const mockPaidServices = [
  {
    id: 'p1',
    name: '软装全案设计',
    icon: '🎨',
    price: 199,
    period: '单套',
    desc: '资深设计师主理全屋软装方案，含色彩搭配、家具选配与窗帘布艺整体规划。',
    features: ['1 对 1 主案设计', '3D 效果图呈现', '落地陪购服务', '2 次方案修改'],
  },
  {
    id: 'p2',
    name: '私享家居管家',
    icon: '🛡️',
    price: 299,
    period: '年',
    desc: '全年家居养护与软装焕新咨询，专属客服随叫随到，省心托管您的家。',
    features: ['全年专属客服', '软装焕新咨询', '家居保养提醒', '会员日双倍积分'],
  },
  {
    id: 'p3',
    name: '大师私定制',
    icon: '👑',
    price: 599,
    period: '单套',
    desc: '首席设计师亲自主理，多轮深度方案打磨，私享样板间级居住体验。',
    features: ['首席设计师主理', '多轮深度方案', '私享样板间', '终身软装顾问'],
  },
];

// 我的优惠券（账户页展示）
export const mockCoupons = [
  { id: 'c1', name: '全屋定制立减券', value: '¥1000', cond: '满 20000 元可用', expire: '2026.12.31', type: '满减' },
  { id: 'c2', name: '软装设计 8 折券', value: '8 折', cond: '软装设计订单可用', expire: '2026.10.31', type: '折扣' },
  { id: 'c3', name: '软装焕新券', value: '¥800', cond: '软装设计订单可用', expire: '2026.09.30', type: '满减' },
  { id: 'c4', name: '成品家具抵用券', value: '¥500', cond: '满 3000 元可用', expire: '2026.11.15', type: '满减' },
];
